import React from 'react';

interface IPopoverProps {
    content: string;
}

const setPopover = (selector: string) => {
    const $ = window.jQuery;

    if (typeof $().emulateTransitionEnd === undefined) {
        setTimeout(() => {
            setPopover(selector);
        }, 100);
    } else {
        $(selector).popover();
    }
};

export const createPopover = (tag?: string) => {
    const selector = tag || '[data-toggle="popover"]';
    setPopover(selector);
};

const Popover = ({ content }: IPopoverProps) => {
    return (
        <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
                href="#"
                onClick={(e) => e.preventDefault()}
                data-toggle="popover"
                data-container="body"
                data-placement="top"
                data-content={content}
                data-trigger="hover"
            >
                <i className="fa fa-info-circle" aria-hidden="true" />
            </a>
        </>
    );
};

export default Popover;
